<template>
  <el-container>
    <img class="banner" src="../assets/img/information.jpg" />
    <div class="bg-box">
      <el-aside width="315px">
        <left-menu :menuList="menuList" :activeMenuIndex="activeMenu" @activeMeun="activeMeun"></left-menu>
      </el-aside>
      <div class="right-text">
        <div class="title1">{{activeText}}</div>
        <div class="title2">{{activeTextEng}}</div>
        <el-divider></el-divider>
        <div v-if="activeText=='企业信息'">
          <el-row>
            <el-col :span="16">
              <img class="mainimage" src="../assets/img/licence03.jpg" />
              <img class="mainimage" src="../assets/img/business-license01.jpg" />
              <img class="mainimage" src="../assets/img/xinxi.jpg" />

              <a href = "http://icid.iachina.cn/">中国保险行业协会信息披露</a>
            </el-col>
            <el-col :span="12">

            </el-col>
          </el-row>
        </div>


        <div v-show="activeText=='信息披露'">
          <el-table :data="DataTable" border style="width: 100%">
            <el-table-column prop="company" label="合作平台名称" width="130"></el-table-column>
            <el-table-column prop="time" label="业务合作时间" width="190"></el-table-column>
            <el-table-column label="合作范围" width="150">
              <template slot-scope="scope">
                <el-button
                  @click="handleClickDetail(scope.row.company,)"
                  type="text"
                  size="small"
                  style="color:red;font-size: 12px;"
                >查看详情</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="mechanism" label="分支机构" width="173">
              <template slot-scope="scope">
                <el-button
                  @click="handleClickDetails(scope.row.company)"
                  type="text"
                  size="small"
                  style="color:red;font-size: 12px;"
                >查看详情</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="保险公司网址" width="373"></el-table-column>
            <el-table-column prop="phone" label="客服/投诉方式" width="373"></el-table-column>
          </el-table>

          <div class="block">
            <el-pagination
              @size-change="SizeChange"
              @current-change="CurrentChange"
              :page-size="pageNum"
              background
              size="mini"
              layout="prev, pager, next, jumper, total"
              :total="total"
            ></el-pagination>
          </div>
          <el-col :span="30">
          <font size="4" color=""></font>
          <p><font size="4" color="">投保咨询、保单查询方式：</font> </p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;客服电话：0411-88891566<br>
                 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;客户投诉渠道：0411-88891566<br>
          <p><font size="4" color="">针对消费者个人信息、投保交易信息和交易安全的保障措施：</font></p>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;辽宁福保保险经纪有限公司郑重承诺，严格遵守现行的关于个人信息、数据及隐私保护的法律法规，采取充分的技术手段和制度管理，对客户的信息、投保交易信息和交易安全采取保障措施和承担保密义务，未经用户同意，本自营平台不会搜集任何用户的资料。因服务需要，通过本自营平台获得和掌握的用户填报资料等涉及个人隐私的信息，富诚保险经纪将予以严格保密并不向任何富诚保险经纪承担相应职责的关联公司以外的第三方透漏和提供。<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 但下列情况除外：<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1、事先获得用户的明确授权；<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2、根据相关法律法规的要求；<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3、根据法院或仲裁机构的裁判或是裁决，以及其他司法程序的要求；<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4、应相关政府部门或监管机构的要求；<br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5、用户违反服务条款或有其他损害富诚保险经纪利益的行为。<br>
          <p><font size="4" color="">自营网络平台在中国保险行业协会官方网站上的信息披露访问链接：</font> </p>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; http://icid.iachina.cn/选择“互联网保险信息披露 >辽宁福保保险经纪有限公司 ”即可查看
            </el-col>
        </div>

        <div v-show="activeText=='互联网产品名录'">
          <el-table :data="DataTableINTS" border style="width: 100%" @cell-click="tableClick">
            <el-table-column prop="company" label="保险公司" width="100"></el-table-column>
            <el-table-column prop="productname" label="产品名称" width="240"></el-table-column>
            <el-table-column prop="filingNo" label="备案编号" width="250"></el-table-column>
            <el-table-column prop="filingclause" label="备案条款" width="270"></el-table-column>
            <el-table-column label="费率表" width="103">
              <template slot-scope="scope">
                <el-button
                  @click="handleClickINT(scope.row.detailType,scope.row.productname)"
                  type="text"
                  size="small"
                  style="color:red;font-size: 12px;"
                >查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination
              @size-change="SizeChangeINT"
              @current-change="CurrentChangeINT"
              :page-size="pageNumINT"
              background
              size="mini"
              layout="prev, pager, next, jumper, total"
              :total="totalINT"
            ></el-pagination>
          </div>
        </div>


      </div>
    </div>
  </el-container>
</template>

<script>
import leftMenu from "@/components/leftMenu";
export default {
  name: "information",
  components: {
    leftMenu
  },
  data() {
    return {
      menuList: ["企业信息", "信息披露", "互联网产品名录"],
      activeText: "",
      activeMenu: 0,
      pageNum: 10,
      total: 0,
      pageNumINT: 10,
      totalINT: 8,
      DataTable: [
        {
        company:'和谐健康' ,
        type:'网站(http://www.hexiehealth.com/)',
        time:'2021.6.1-2024.5.31',
        clause:'福家保重大疾病保险,福满一生, 慧馨安少儿终身,慧馨安少儿定期 （30年）,慧馨安少儿定期 （70/80岁）,福满一生',
        mechanism:'福建分公司,泉州中心支公司,黑龙江分公司,大庆中心支公司,辽宁分公司,鞍山中心支公司,营口中心支公司,抚顺中心支公司,盘锦中心支公司,丹东中心支公司,广东分公司,东莞中心支公司,茂名中心支公司,珠海中心支公司,浙江分公司,金华中心支公司,嘉兴中心支公司,绍兴中心支公司,温州中心支公司,深圳分公司,深圳分公司龙岗支公司,湖北分公司,荆州中心支公司,襄阳中心支公司,孝感中心支公司,十堰中心支公司,山东分公司,济宁中心支公司,泰安中心支公司,潍坊中心支公司,安徽分公司,宿州中心支公司,滁州中心支公司,芜湖中心支公司,江苏分公司,苏州中心支公司,苏州中支张家港支公司,苏州中心支公司常熟支公司,常州中心支公司,无锡中心支公司,南通中心支公司,徐州中心支公司,淮安中心支公司,泰州中心支公司,四川分公司, 绵阳中心支公司,乐山中心支公司,宜宾中心支公司,北京分公司,北京分公司朝阳支公司,河北分公司,秦皇岛中心支公司,唐山中心支公司,陕西分公司,扬州中心支公司,上海分公司',
        phone:'客服/投诉电话：956076'
        },
        {
        company:'弘康人寿' ,
        type:'网站(https://www.hongkang-life.com/hongkang/index.html)',
        time:'2020.7.20-2021.12.31',
        clause:'弘康哆啦A保重大疾病保险,弘康爱倍至（至尊版）重大疾病保险,弘康安享长盈终身寿险',
        mechanism:'弘康人寿保险股份有限公司,河南分公司,江苏分公司,上海分公司',
        phone:'客服/投诉电话：4008-500-365'
        }
      ],
      DataTableS: [],
      DataTableINTS: [
       
      ],
      DataTableINT: [
        {
          company: " 和谐健康保险股份公司",
          productname: "慧馨安少儿定期重大疾病保险（甄选版）",
          filingclause:
            "和谐慧馨安少儿定期重大疾病保险（甄选版）",
          filingNo: "和谐健康[2020]疾病保险005号",
          type: "03",
          detailType: "303"
        },
        {
          company: " 和谐健康保险股份公司",
          productname: "慧馨安少儿终身重大疾病保险（甄选版）",
          filingclause:
            "和谐慧馨安少儿终身重大疾病保险（甄选版）",
          filingNo: "和谐健康[2020]疾病保险006号",
          type: "03",
          detailType: "303"
        },
        {
          company: " 和谐健康保险股份公司",
          productname: "和谐福家保重大疾病保险",
          filingclause:
            "和谐福家保重大疾病保险",
          filingNo: "和谐健康[2020]疾病保险029号",
          type: "03",
          detailType: "303"
        },
        {
          company: " 和谐健康保险股份公司",
          productname: "和谐福满一生重大疾病保险",
          filingclause:
            "和谐福满一生重大疾病保险",
          filingNo: "和谐健康[2020]疾病保险022号",
          type: "03",
          detailType: "303"
        },
        {
          company: " 和谐健康保险股份公司",
          productname: "附加投保人豁免保险费重大疾病保险",
          filingclause:
            "和谐附加投保人豁免保险费重大疾病保险",
          filingNo: "和谐健康[2020]疾病保险003号",
          type: "03",
          detailType: "303"
        },
        {
          company: " 弘康人寿保险股份有限公司",
          productname: "弘康哆啦A保重大疾病保险",
          filingclause:
            "弘康哆啦A保重大疾病保险",
          filingNo: "弘康哆啦A保重大疾病保险",
          type: "03",
          detailType: "303"
        },
        {
          company: " 弘康人寿保险股份有限公司",
          productname: "弘康爱倍至（至尊版）重大疾病保险",
          filingclause:
            "弘康爱倍至（至尊版）重大疾病保险",
          filingNo: "弘康爱倍至（至尊版）重大疾病保险",
          type: "03",
          detailType: "303"
        },
        {
          company: " 弘康人寿保险股份有限公司",
          productname: "弘康安享长盈终身寿险",
          filingclause:
            "弘康安享长盈终身寿险",
          filingNo: "弘康安享长盈终身寿险",
          type: "03",
          detailType: "303"
        }
      ]
    };
  },
  computed: {
    activeTextEng() {
      switch (this.activeText) {
        case "企业资质":
          return "ENTERPRISE QUALIFICATION";
          break;
        case "信息披露":
          return "INFORMATION DISCLOSURE";
          break;
        case "互联网产品名录":
          return "INTERNET PRODUCT LIST";
          break;
        default:
          break;
      }
    }
  },
  created() {
    this.$nextTick(() => {
      if (this.$route.query.id) {
        this.activeText = this.$route.query.id;
        if (this.$route.query.id == "互联网产品名录") {
          this.activeMenu = 2;
        }
        if (this.$route.query.id == "信息披露") {
          this.activeMenu = 1;
        }
      }
      window.scrollTo(0, 0);
    });
  },
  methods: {
    activeMeun(data) {
      if (this.DataTableINT.length > 10) {
        this.DataTableINTS = this.DataTableINT.slice(0, 10);
      }
      this.activeText = data;
    },
    //第三方合作平台披露-每页条数设置
    SizeChange() {},
    //第三方合作平台披露-table分页跳转
    CurrentChange() {},
    //互联网产品名录-查看详情
    handleClickINT(row, name) {
      this.$router.push({
        path: "/infoDetail",
        query: { type: row, name: `${name}费率表` }
      });
    },
    handleClickDetail(row){
      this.$router.push({
        path: "/infoDetail",
        query: { type: row, name: `合作范围` }
      });
    },
    handleClickDetails(row){
      this.$router.push({
        path: "/infoDetail",
        query: { type: row, name: `分支机构` }
      });
    },
    //互联网产品名录-每页条数设置
    SizeChangeINT() {},
    //互联网产品名录-table分页跳转
    CurrentChangeINT(data) {
      if (data == 2) {
        this.DataTableINTS = this.DataTableINT.slice(10, 20);
      } else {
        this.DataTableINTS = this.DataTableINT.slice(0, 10);
      }
    },
    tableClick(row, column) {
      console.log(row, "rowrowrowrowrowrow");
      if (column.property == "filingclause") {
        this.$router.push({
          path: "/infoDetail",
          query: { type: row.type, name: row.filingclause }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-aside {
  overflow: hidden;
}
/deep/ .el-divider {
  background-color: $font-color-gary2;
  margin-bottom: 35px;
}
.el-container {
  flex-wrap: wrap;
}
.banner {
  margin-bottom: 30px;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center top;
}
.bg-box {
  width: 100%;
  min-width: 1050px;
  box-sizing: border-box;
  display: flex;
  margin: 0 15%;
  .right-text {
    max-width: 964px;
    min-width: 600px;
    text-align: left;
    margin: 0 0 100px 50px;
    .title1 {
      margin: 0px 0 4px 0;
      font-size: $font-size-lv1;
      color: $font-color-main;
    }
    .title2 {
      margin: 0 0 35px 0;
      font-size: $font-size-lv5;
      color: $font-color-gary1;
    }
    span {
      font-size: $font-size-lv3;
      color: $font-color-gary1;
      line-height: 36px;
    }
  }
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: $green !important;
  color: #fff;
}
/deep/ .el-pagination.is-background .el-pager li:hover {
  color: $green !important;
}
.mainimage {
  margin: 0 auto;
  width: 100%;
  height: 100%;
}
.block {
  width: 100%;
  height: 100%;
  margin-top: 20px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/information.vue